module.exports = __webpack_public_path__ + "static/media/B2.26947db4.jpg";